<script lang="ts" setup>
import type { StrapiBuilderLayoutData } from '@autobid/strapi-integration/typescript/strapi/Page'
import { useBodyStore } from '@autobid/nuxt-pinia-store/store/useBodyStore'
import { DISABLE_MENU_LOGO_LINK_KEY } from '@autobid/ui/constants/DISABLE_MENU_LOGO_LINK_KEY'
import { storeToRefs } from 'pinia'

interface Props {
  logo: NonNullable<NonNullable<StrapiBuilderLayoutData['layout']>['header']>['brand']
}

defineProps<Props>()

const { locale } = useI18n()
const { scrollY } = storeToRefs(useBodyStore())
const isNavbarTransparentVisible = inject<boolean>('isNavbarTransparentVisible')
const disableMenuLogoLink = inject(DISABLE_MENU_LOGO_LINK_KEY)
</script>

<template>
  <common-link
    v-if="logo[0]"
    :href="disableMenuLogoLink ? '' : logo[0].url ?? `/${locale}`"
    class="nav-logo relative max-w-[12rem] px-5"
    :class="{
      scrolled: scrollY > 0,
    }"
  >
    <CommonStrapiImage
      v-if="isNavbarTransparentVisible && logo[0]?.imageWhite"
      :data="logo[0].imageWhite"
      class="h-20 max-h-[48px] w-full object-contain lg:max-h-[64px] 2xl:max-h-[80px]"
    />
    <CommonStrapiImage
      v-else-if="logo[0]?.image"
      :data="logo[0].image"
      class="h-20 max-h-[48px] w-full object-contain lg:max-h-[64px] 2xl:max-h-[80px]"
    />
  </common-link>
</template>

<style lang="scss" scoped>
.nav-logo {
  transition: 0.3s top;
}

@media (min-width: 1024px) {
  .nav-logo.scrolled {
    top: 0;
  }
}

@media (min-width: 1680px) {
  .nav-logo {
    top: 32px;
    margin-left: 2.5rem;
  }
}
</style>
